/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsTenantLight extends models.FilterOptionsBase {
    getFixupPrototypeFunction() { return FilterOptionsTenantLight.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsTenantLight>): FilterOptionsTenantLight {
        let obj = Object.assign(new FilterOptionsTenantLight(), model);
        FilterOptionsTenantLight.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsTenantLight>): FilterOptionsTenantLight {
        if (!model) return null;
        return FilterOptionsTenantLight.newInstance(<FilterOptionsTenantLight> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsTenantLight) {
        if (!obj) return;

        models.FilterOptionsTenantLight.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsTenantLight): boolean {
        if (models.FilterOptionsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsTenantLight.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cloud_providers) {
            for (let val of this.cloud_providers) {
                models.FilterOptionsCloudProviderLight.fixupPrototype(val);
            }
        }
        if (this.ai_providers) {
            for (let val of this.ai_providers) {
                models.FilterOptionsForSaasAiServices.fixupPrototype(val);
            }
        }
        if (this.data_service_providers) {
            for (let val of this.data_service_providers) {
                models.FilterOptionsForSaasDataServices.fixupPrototype(val);
            }
        }
        if (this.other_service_providers) {
            for (let val of this.other_service_providers) {
                models.FilterOptionsForSaasOtherServices.fixupPrototype(val);
            }
        }
        if (this.container_providers) {
            for (let val of this.container_providers) {
                models.FilterOptionsCloudProviderLight.fixupPrototype(val);
            }
        }
        if (this.platform_providers) {
            for (let val of this.platform_providers) {
                models.FilterOptionsPlatformProviderLight.fixupPrototype(val);
            }
        }
    }

    cloud_providers: Array<models.FilterOptionsCloudProviderLight>;

    ai_providers: Array<models.FilterOptionsForSaasAiServices>;

    data_service_providers: Array<models.FilterOptionsForSaasDataServices>;

    other_service_providers: Array<models.FilterOptionsForSaasOtherServices>;

    /**
     * Currencies
     */
    dimension_currencies: Array<models.Currency>;

    container_providers: Array<models.FilterOptionsCloudProviderLight>;

    platform_providers: Array<models.FilterOptionsPlatformProviderLight>;

}
